<template>
    <v-container fluid style="padding: 20px">
        <v-list   class="c-grey text-left">
            <v-list-item 
            v-for="item in basicListArray"
            :key="item"
            >
            {{ "•  " + item }}
            </v-list-item>
        </v-list>
    </v-container>
</template>


<script>


export default {
  name: "basic-list",
  data () {
  return {
    basicListArray: []
    }
  },
  props: {
    basicListItems: {
      type: String,
      default: ""
    }
  },
  created () {
    this.listToArray();
  },
  watch: {
    basicListItems: function() {
    this.listToArray();
    }
  },
  methods: {
    listToArray() {
      if (this.basicListItems != null && this.basicListItems.length > 0){
        //console.log("*****************************************")
        //console.log(this.basicListItems);
        this.basicListArray = this.basicListItems.split("|") ;
        //console.log(this.basicListArray);
      }
    }
  }

};

</script>


// WEBPACK FOOTER //
// src/components/BasicList.vue